import { BottomsheetShared } from './../../general/shared/bottomsheet-shared';
import { SupportService } from './../../../data/repository/support-repository/support.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-support-bottomsheet',
  templateUrl: './support-bottomsheet.component.html',
  styleUrls: ['./support-bottomsheet.component.scss'],
})
export class SupportBottomsheetComponent implements OnInit {
  constructor(
    private supportService: SupportService,
    private bottomsheetShared: BottomsheetShared
  ) {}

  ngOnInit() {}
  phone() {
    this.bottomsheetShared.closeBottomsheet();
  }
  sendReports() {
    this.supportService.messageBS.next(true);
  }
}
